<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <div v-if="$scopedSlots.before">
      <slot name="before"/>
    </div>
    <editor v-model="inputVal" :editorToolbar="customToolbar"
            useCustomImageHandler
            @image-added="handleImageAdded"
            :placeholder="placeholder"/>
  </b-form-group>
</template>

<script>
import {VueEditor} from "vue2-editor";

export default {
  components: {
    'editor': VueEditor
  },
  props: {
    model: Object,
    attribute: String,
    label: String,
    errors: Array,
    placeholder: String,
    maxLength: {type: Number, default: 20000},
    errorOnly: Boolean,
    height: {type: Number, default: 500},
    plugins: {type: Array, default: null}
  },
  data() {
    return {
      service: '/upload/image',
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
      state: null,
      errorTxt: '',
      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6]
          },
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {
            align: ""
          },
          {
            align: "center"
          },
          {
            align: "right"
          },
          {
            align: "justify"
          }
        ],
        ["blockquote", "code-block"],
        [
          {
            list: "ordered"
          },
          {
            list: "bullet"
          },
          {
            list: "check"
          }
        ],
        [
          {
            indent: "-1"
          },
          {
            indent: "+1"
          }
        ], // outdent/indent
        [
          {
            color: []
          },
          {
            background: []
          }
        ], // dropdown with defaults from theme
        ["link", "image", "video"], ["clean"] // remove formatting button
      ]
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        this.inputVal = val[this.attribute];
      }, deep: true
    },
    inputVal(val) {
      this.state = null;
      this.errorTxt = '';
      this.model[this.attribute] = val;
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      if (!this.errorOnly) {
        this.state = !hasErr;
      }
    }
  },
  methods: {
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      this.$emit('startLoading');

      let formData = new FormData();
      formData.append("file", file);

      this.$service.post(this.service, formData).then(result => {
        if (result.data && result.data.length) {
          Editor.insertEmbed(cursorLocation, "image", result.data[0].url);
          resetUploader();
        }
      }).finally(() => {
        this.$emit('change');
        this.showLoading = false;
      });
    }
  },
}
</script>